import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
// Custom components
import Caption from '../../../components/Caption';
import { Icon12 } from '../../../components/Icon';
// Images
import ChevronSrc from '../../../images/chevronBoldBlue.svg';

const Navigate = styled(NavLink)`
  ${tw`inline-flex items-center cursor-pointer
    mt-1 no-underline`}
  margin-left: 20px;
  padding-bottom: 10px;
`;

const Chevron = styled.img`
  ${Icon12}
  transform: rotate(180deg);
  margin-right: 6px;
`;

const LinkHeader = styled(Caption)`
  ${tw`hover:underline`}
`;

const Redirect = ({ methods, text, url }) => (
  <Navigate onClick={() => methods()} to={url}>
    <Chevron src={ChevronSrc} />
    <LinkHeader>{text}</LinkHeader>
  </Navigate>
);

Redirect.propTypes = {
  methods: PropTypes.func,
  text: PropTypes.string,
  url: PropTypes.string,
};

Redirect.defaultProps = {
  url: '/faq',
  methods: () => {},
};

export default Redirect;
